<template>
  <sticky-tabs-bar class="product-tabs-bar fixed" :tabs="tabs" @tab-change="handleClickTab" />
</template>

<script setup lang="ts">
import StickyTabsBar from '@/components/common/sticky-tabs-bar.vue'

const emit = defineEmits<{
  (event: 'tab-change', value: string): void
}>()

const props = defineProps<{
  sections: {
    id: string
    show: boolean
    label?: string
  }[]
}>()

const tabs = computed(() => props.sections.filter(section => section.show && section.label).map(s => ({ key: s.id, label: s.label || '' })))

const handleClickTab = (id: string) => {
  emit('tab-change', id)
  scrollToId(id)
}
</script>
